import { PageViewModel } from '@models/common.models';
import { SwoPayoutViewModel } from '@models/SwoPayout';
import { BaseService } from '@services/BaseService';

export interface SwoPayoutSearchRequest {
  readonly orderBy: string;
  readonly orderByDirection: string;
  readonly pageNumber: number;
  readonly pageSize: number;

  // optional parameters
  readonly contractIds?: number[];
  readonly contractNumbers?: string[];
  readonly hasInvoice?: boolean;
  readonly swoIds?: number[];
}

class SwoPayoutService extends BaseService {
  constructor() {
    super('');
  }

  public approve(id: number): Promise<void> {
    return this.fetch(`swoPayouts/${id}/approve`, { method: 'PUT' });
  }

  public delete(id: number): Promise<void> {
    return this.fetch(`swoPayouts/${id}`, { method: 'DELETE' });
  }

  public search(request: SwoPayoutSearchRequest): Promise<PageViewModel<SwoPayoutViewModel>> {
    const queryParameters: string[] = [
      `orderBy=${request.orderBy}`,
      `orderByDirection=${request.orderByDirection}`,
      `pageNumber=${request.pageNumber}`,
      `pageSize=${request.pageSize}`
    ];
    if (request.contractIds != null) {
      for (let ci of request.contractIds) {
        queryParameters.push(`contractIds=${ci}`);
      }
    }
    if (request.contractNumbers != null) {
      for (let ci of request.contractNumbers) {
        queryParameters.push(`contractNumbers=${ci}`);
      }
    }
    if (request.hasInvoice != null) {
      queryParameters.push(`hasInvoice=${request.hasInvoice!}`);
    }
    if (request.swoIds != null) {
      for (let ci of request.swoIds) {
        queryParameters.push(`swoIds=${ci}`);
      }
    }

    const query = 'swoPayouts?'.concat(queryParameters.join('&'));

    return this.fetch<PageViewModel<SwoPayoutViewModel>>(query, {
      method: 'GET'
    });
  }
}

export const swoPayoutSerivce = new SwoPayoutService();



// WEBPACK FOOTER //
// ./src/_services/SwoPayoutService.ts